import { defineMessages } from 'react-intl';

export default defineMessages({
  coupon: {
    id: 'shop.cart.coupon',
    defaultMessage: 'Voucher',
  },
  applyCoupon: {
    id: 'shop.cart.couponApply',
    defaultMessage: 'Redeem',
  },
  removeCoupon: {
    id: 'shop.cart.couponRemove',
    defaultMessage: 'Remove',
  },
});
